import { getFixedStoreAlias } from "@/helpers/urlHelper";

const POLO_BISTRO_PATH_SEGMENT = "/polobistro";
const POLO_BISTRO_ALIAS = "polobistro";
const POLO_BISTRO_HOSTNAME = "polobistro.com";
const DEFAULT_QUANTITY_SELECT_MAX = 50;

export function isPoloBistroUrl(pathname) {
  // Single-store mode: VUE_APP_STORE_ALIAS=polobistro (served at domain root,
  // so there is no /polobistro path segment to match).
  if (getFixedStoreAlias().toLowerCase() === POLO_BISTRO_ALIAS) {
    return true;
  }

  // Custom domain: polobistro.com (also matches www.polobistro.com).
  if (
    typeof window !== "undefined" &&
    window.location?.hostname?.toLowerCase().includes(POLO_BISTRO_HOSTNAME)
  ) {
    return true;
  }

  // Multi-tenant mode: /polobistro path segment.
  const path =
    pathname || (typeof window !== "undefined" ? window.location.pathname : "");

  return path.toLowerCase().includes(POLO_BISTRO_PATH_SEGMENT);
}

export function getQuantitySelectOptions(
  currentQuantity = 1,
  { min = 1, max = DEFAULT_QUANTITY_SELECT_MAX } = {}
) {
  const minValue = Number.isFinite(Number(min)) ? Number(min) : 1;
  const maxValue =
    max != null && Number.isFinite(Number(max))
      ? Number(max)
      : DEFAULT_QUANTITY_SELECT_MAX;
  const currentValue = Number.isFinite(Number(currentQuantity))
    ? Number(currentQuantity)
    : minValue;
  const upperBound = Math.max(minValue, maxValue);
  const options = [];

  for (let quantity = minValue; quantity <= upperBound; quantity += 1) {
    options.push(quantity);
  }

  if (currentValue > upperBound) {
    options.push(currentValue);
  }

  return options;
}
